import type { JSX } from 'solid-js';
import { AdminAccessRequestsPanel } from '../components/AdminAccessRequestsPanel';
import { AdminGate } from '../components/AdminGate';
import { SESSION_TOKEN } from '../lib/session';

// Access-request inbox route (arc 101 slice 01). Thin: <AdminGate/> keeps the
// panel (and its `/v1/admin/access-requests` reads + invite/decline writes)
// behind the closed-beta staff wall. `token` is injectable for tests; the
// router mounts with no props.
//
// The WALL is not the fence. Staff sessions read the inbox; the invite is a
// provision under `admin:users` + `admin:grants` and the decline under
// `admin:users`, which no session carries, so each first asks the door for a
// one-hour operator credential (`lib/access-request-actions.ts`, #5724). The
// door's own refusal renders `<OperatorRefusalAlert/>`; a write the API refuses
// shows its own 403 inline, in the dialog.

export function AdminAccessRequests(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminAccessRequestsPanel token={token} />
    </AdminGate>
  );
}
